<template>
  <section class="personal-space-layout">
    <section class="sidebar">
      <personal-space-sidebar-element />
    </section>

    <section class="main">
      <slot />
    </section>
  </section>
</template>

<script>
import PersonalSpaceSidebarElement from '@/components/elements/PersonalSpaceSidebarElement';

export default {
  name: 'PersonalSpaceLayoutTwo',
  components: {
    PersonalSpaceSidebarElement,
  },
};
</script>

<style lang="scss" scoped>
@import '@/constants/variables.module.scss';
.personal-space-layout {
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
}
.sidebar {
  border-right: 1px solid $medium-gray;
  padding: 28px 0 0 24px;
  width: 272px;
  display: flex;
  flex-flow: column;
  min-height: 100vh;
}
.main {
  width: calc(100% - 272px);
  min-width: 300px;
}
</style>
